import { useState } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
const timezones = [
  { label: "SGT", value: "Asia/Singapore" },
  { label: "IST", value: "Asia/Kolkata" },
  { label: "GMT (UK)", value: "Europe/London" },
  { label: "EST", value: "America/New_York" },
  { label: "CST", value: "America/Chicago" },
  { label: "MST", value: "America/Denver" },
  { label: "PST", value: "America/Los_Angeles" },
];


export default function Preferability() {
  const savedTimezone = localStorage.getItem("timezone");

const [timezone, setTimezone] = useState(
  timezones.some(tz => tz.value === savedTimezone)
    ? savedTimezone
    : ""
);


  const [timeFormat, setTimeFormat] = useState(
    localStorage.getItem("timeFormat") || "24"
  );

  const handleSave = () => {
    if (!timezone) {
      toast.error("Please select a timezone");
      return;
    }

    localStorage.setItem("timezone", timezone);
    localStorage.setItem("timeFormat", timeFormat);
    toast.success("Preferences saved successfully!");
  };



  const logout = () => {
    localStorage.removeItem("user");
    window.location.href = "/login";
  };

  return (
    <>
      <div className="px-8 py-8">
        <Navbar logout={logout} />
        {/* BACK */}
        <div className="flex flex-wrap">
          <Button variant="outline" asChild className="neon-left ml-auto">
            <Link to="/">Back</Link>
          </Button>
        </div>

        {/* CENTER CARD */}
        <div className=" flex  justify-center">
          <Card className="relative w-[420px] neon-card rounded-2xl">
            <CardHeader>
              <CardTitle className="text-xl font-semibold">
                Preferability Setting
              </CardTitle>
            </CardHeader>

            <CardContent className="space-y-6">
              {/* TIMEZONE */}
              <div className="space-y-2">
                <label className="text-sm text-black/60 dark:text-white/60">Select Timezone</label>

                <Select value={timezone} onValueChange={setTimezone} className="neon-left neon-input-wrapper">
                  <SelectTrigger className="bg-transparent rounded-full h-11 neon-input outline-none">
                    <SelectValue placeholder="Choose timezone" />
                  </SelectTrigger>
                  <SelectContent>
{timezones.map((tz) => (
  <SelectItem key={tz.value} value={tz.value}>
    {tz.label}
  </SelectItem>
))}

                  </SelectContent>
                </Select>
              </div>

              {/* TIME FORMAT */}
              <div className="space-y-3">
                <label className="text-sm text-black/60 dark:text-white/60">Time Format</label>

                <div className="flex gap-4">
                  <button
                    onClick={() => setTimeFormat("12")}
                    className={`px-6 py-2 rounded-full text-sm transition
                    ${
                      timeFormat === "12"
                        ? "border border-neon text-neon"
                        : "border border-white/10 text-black/60 dark:text-white/60  hover:text-neon"
                    }`}
                  >
                    12 Hour
                  </button>

                  <button
                    onClick={() => setTimeFormat("24")}
                    className={`px-6 py-2 rounded-full text-sm transition
                    ${
                      timeFormat === "24"
                        ? "border border-neon text-neon"
                        : "border border-white/10 text-black/60 dark:text-white/90  hover:text-neon"
                    }`}
                  >
                    24 Hour
                  </button>
                </div>
              </div>

              {/* SAVE */}
              <Button
                onClick={handleSave}
                className="bg-neon text-black rounded-xl px-8 w-fit"
              >
                Save
              </Button>
            </CardContent>
          </Card>
        </div>
        <Footer />
      </div>
    </>
  );
}
